import axios from "axios";
import { config, getDomain, tempAlErr, tempAlWait } from "../helpers"
import { alertIndex } from "../helpers/alertIndex";
import { CONT_COORD, CONT_HOME_ADMIN, CONT_LIST, CONT_LIST_ADMIN, CONT_NBREAD, CONT_NBREAD_ADMIN, CONT_SEND, CONT_SEND_ADMIN, NEWS_NB, NEWS_SAVE, NEWS_SEND } from "./action-types";

// Envoyer un message
export function sendContact({
    message,
    file
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/tchat/send`, {
            message: message,
            file: file
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CONT_SEND,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcse003");
                dispatch({
                    type: CONT_SEND,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Sauvegarder les coordonnées
export function saveCoord({
    email,
    name
}) {
    return function (dispatch) {
        let alert = tempAlWait();

        axios.post(`${getDomain()}api/tchat/coord`, {
            email: email,
            name: name
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: CONT_COORD,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcco003");
                dispatch({
                    type: CONT_COORD,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Envoyer un message (admin)
export function sendAdminContact({
    message,
    file,
    ip
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let isNext = false;

        axios.post(`${getDomain()}api/tchat/send-admin`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            message: message,
            file: file,
            ip: ip
        }, config) 
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    isNext = true;
                }

                dispatch({
                    type: CONT_SEND_ADMIN,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcsa005");
                dispatch({
                    type: CONT_SEND_ADMIN,
                    payload: {
                        alert: alert,
                        isNext: isNext
                    }
                })
            })
    }
}

// Liste des messages
export function getContact() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];

        axios.post(`${getDomain()}api/tchat/list`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CONT_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcli002");
                dispatch({
                    type: CONT_LIST,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Liste des messages (admin)
export function getAdminContact({ip}) {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];

        axios.post(`${getDomain()}api/tchat/list-admin`, {
            ip: ip,
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CONT_LIST_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcla004");
                dispatch({
                    type: CONT_LIST_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Liste des messages accueil (admin)
export function getAdminHomeContact() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = [];

        axios.post(`${getDomain()}api/tchat/list-admin-home`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred') 
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CONT_HOME_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tclh004");
                dispatch({
                    type: CONT_HOME_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Obtenir le nombre de message non lu pour un user
export function getNbMessNoRead()
{
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = 0;

        axios.post(`${getDomain()}api/tchat/nb-noread`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CONT_NBREAD,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcnblu002");
                dispatch({
                    type: CONT_NBREAD,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Obtenir le nombre de message non lu pour l'admin
export function getNbMessNoReadAdmin()
{
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = 0;

        axios.post(`${getDomain()}api/tchat/nb-admin-noread`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred')
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: CONT_NBREAD_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("tcnbluad004");
                dispatch({
                    type: CONT_NBREAD_ADMIN,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}

// Sauvegarde newsletter
export function saveNewsletter({
    name,
    email
}) {
    return function (dispatch) {
        let alert = tempAlWait();

        axios.post(`${getDomain()}api/newsletter/save`, {
            email: email,
            name: name
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: NEWS_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("nlsa004");
                dispatch({
                    type: NEWS_SAVE,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Envoyer newsletter
export function sendNewsletter({
    contenu,
    objet
}) {
    return function (dispatch) {
        let alert = tempAlWait();
        
        axios.post(`${getDomain()}api/newsletter/send`, {
            userId: localStorage.getItem('userId'),
            credentials: localStorage.getItem('userCred'),
            content: contenu,
            objet: objet
        }, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                dispatch({
                    type: NEWS_SEND,
                    payload: {
                        alert: alert
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr('nlse005');
                dispatch({
                    type: NEWS_SEND,
                    payload: {
                        alert: alert
                    }
                })
            })
    }
}

// Obtenir le nombre de personnes présentes dans la newsletter
export function getNewsNb() {
    return function (dispatch) {
        let alert = tempAlWait();
        let datas = 0;

        axios.post(`${getDomain()}api/newsletter/nb`, {}, config)
            .then(res => {
                res = res.data;
                alert = alertIndex(res.res.code);

                if (res.res.type == "succ") {
                    datas = res.datas;
                }

                dispatch({
                    type: NEWS_NB,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
            .catch(err => {
                console.log(err);
                alert = tempAlErr("nlnb002");
                dispatch({
                    type: NEWS_NB,
                    payload: {
                        alert: alert,
                        datas: datas
                    }
                })
            })
    }
}